import axios from "axios";
import humps from "humps";
// import Vue from 'vue'
import alert from "@/_helpers/alert";
// import { BASE_API_URL, HTTP_REQUEST_TIMEOUT } from '@/utils/constants'

// import i18n from '@/locale'
let adminToken = localStorage.getItem("token");
axios.defaults.baseURL = process.env.VUE_APP_ENDPOINT_BACKEND;
axios.defaults.headers.common["Authorization"] = `Bearer ${adminToken}`;

const axiosInstance = axios.create({
  baseURL: process.env.VUE_APP_ENDPOINT_BACKEND,
  timeout: 120000
});

export const requestInterceptor = {
  interceptor: config => {
    function isFormData(value) {
      try {
        var test = new FormData().has, // Throws in old browsers
          isFormData = test.call(value, 0) || true; // Throws if not a FormData instance
      } catch (e) {
        isFormData = !test && {}.toString.call(value) == "[object FormData]";
      }
      return isFormData;
    }
    const newConfig = config;
    if (isFormData(newConfig.data)) {
      return newConfig;
    } else {
      newConfig.data = humps.decamelizeKeys(newConfig.data, (key, convert) => (key.charAt(0) === "_" ? key : convert(key)));
      newConfig.params = humps.decamelizeKeys(newConfig.params, { separator: "-" });
      return newConfig;
    }
  },
  error: error => Promise.reject(error)
};

export const responseInterceptor = {
  // interceptor: response => humps.camelizeKeys(response.data, (key, convert) => (key.charAt(0) === '_' ? key : convert(key))),
  interceptor: response => {
    return { status: response.status == 200, ...response.data };
  },
  error: async error => {
    console.log("error-test");
    // Do something with response error
    const handleError = {
      data: error.response,
      error: error?.response?.data
    };
    if (error.response) {
      if (parseInt(error.response.status, 10) === 401 || parseInt(error.response.status, 10) === 403) {
        alert.error("เซสชั่นของคุณหมดอายุ กรุณาล็อคอินอีกครั้ง");
        window.location.href = `/user/logout`;
      } else if (parseInt(error.response.status, 10) === 403) {
        alert.error("คุณไม่มีสิทธิในการเข้าถึง");
        return {
          status: false,
          message: handleError?.data?.data
        };
      }
    }

    alert.error("ไม่สามารถดึงข้อมูลได้");
    console.log(error, "error");
    return {
      status: false,
      message: handleError?.data?.data
    };
  }
};

axiosInstance.interceptors.request.use(requestInterceptor.interceptor, requestInterceptor.error);

// // Add a response interceptor
axiosInstance.interceptors.response.use(responseInterceptor.interceptor, responseInterceptor.error);

class HttpRequest {
  constructor() {
    this.axios = axios;
  }
  setToken = value => {
    let adminToken = value;
    axiosInstance.defaults.headers.common["Authorization"] = `Bearer ${adminToken}`;
  };

  setHeader = header => {
    // axios.defaults.headers.post['Content-Type'] = 'application/application/json'
    axiosInstance.defaults.headers.post["Content-Type"] = "application/application/json";
    axiosInstance.defaults.headers.common[header.key] = header.value;
  };
  setHeaderFile = () => {
    axiosInstance.defaults.headers.post["Content-Type"] = "multipart/form-data";
    axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
  };

  fetch = (methodName, data) => axiosInstance.get(methodName, { params: data });

  create = (methodName, data) => axiosInstance.post(methodName, data);

  update = (methodName, data, params) => axiosInstance.put(methodName, data, { params });

  edit = (methodName, data) => axiosInstance.patch(methodName, data);

  remove = (methodName, data) => axiosInstance.delete(methodName, { data });

  delete = (methodName, id) => axiosInstance.delete(methodName, { params: { id } });

  static request = (type, url, data, config) => {
    let promise = null;
    switch (type) {
      case "GET":
        promise = axios.get(url, { params: data });
        break;
      case "POST":
        promise = axios.post(url, data, config);

        break;
      case "PUT":
        promise = axios.put(url, data, { params: data });
        break;
      case "PATCH":
        promise = axios.patch(url, data);
        break;
      case "DELETE":
        promise = axios.delete(url, data);
        break;
      default:
        promise = axios.get(url, { params: data });
    }
    return promise;
  };

  static getInstanceHeaders = () => axiosInstance.defaults.headers;
}

export default HttpRequest;
